<template>
  <div class="container  activityIndex assetsList">
    <van-nav-bar title="虚拟资产明细" left-text fixed left-arrow @click-left="onClickLeft" />
    <van-empty description="什么都没有~" v-show="isEmpty" />
    <van-list style="margin-top: -5px" v-model="loading" :finished="finished" :finished-text="finishText" @load="onLoad" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载" :offset="30">
      <div class="pageList">
        <transition-group v-bind:css="false" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter">
          <div class="padding10 pageListItem flexNone" v-for="(item, index) in dataList" :key="item.id" :data-delay="index * 20" data-y="100%" @click="handleRecDeatails(item.id)">
            <van-row type="flex" justify="space-between" class="marginTop3 colorGrey1">
              <!-- 资产变动类型 （1充值 2消费 3退费） -->
              <van-col span="16" class="van-ellipsis colorBlack fz16" v-if='item.type==2'>{{item.activityName}}({{item.typeName}})</van-col>
              <van-col span="16" class="van-ellipsis colorBlack fz16" v-if='item.type==1'>充值({{item.remark}})</van-col>
              <van-col span="16" class="van-ellipsis colorBlack fz16" v-if='item.type==3'>{{item.activityName}}({{item.typeName}})-退费</van-col>
            </van-row>
            <van-row type="flex" justify="space-between" class="marginTop6 colorGrey1">
              <van-col span="24" class="van-ellipsis2">{{item.type==3 &&item.isApply == 3 ?'退费时间':'时间：'}}{{ item.createTime }}</van-col>
            </van-row>
            <div class="integralText">
              <!-- 变动 1增加 2扣除 -->
              <div class="fz16 textBold colorTheme" v-if='item.type==2'>-{{item.money}}元</div>
              <div class="fz16 textBold colorTheme" style="color:#07c160" v-if='item.type==1'>+{{item.money}}元</div>
              <div class="fz16 textBold colorTheme" style="color:#07c160" v-if='item.type==3'>+{{item.money}}元</div>
            </div>
            <div class="refundBtn">
              <van-button color='#E6A23C' round size='small' v-if='item.isApply==1' >退费中</van-button>
              <van-button color='#0A014D' round size='small' v-if='item.isApply==2' @click='handleApplyRefund(item.id)'>申请退费</van-button>
              <van-button color='#67C23A' round size='small' v-if='item.isApply==3' >已退费</van-button>
              <van-button color='#F56C6C' round size='small' v-if='item.isApply==4' >退费失败</van-button>
            </div>
          </div>
        </transition-group>
      </div>
    </van-list>
    <div class="fixedBottomBtn">
      <div class="inner">
        <router-link to="/refundApplyList">
          <van-button type="primary" round block>我的退费申请</van-button>
        </router-link>
      </div>
    </div>
    <van-dialog v-model="dialogVisable" title="" show-cancel-button @confirm='handleSubmitRefund'>
      <van-field v-model="reason" label-width='3em' rows="2" autosize label="原因" type="textarea" maxlength="50" placeholder="请输入退款原因" show-word-limit />
    </van-dialog>
  </div>
</template>

<script>
import { myAssetsList, applyForRefund } from '@/api/data'
export default {
  data() {
    return {
      // dataList: [{id:1},{id:1},{id:1},{id:1},{id:1},{id:1},{id:1},{id:1},{id:1},{id:1},{id:1},],
      dataList:[],
      pageInfo: {
        page: 1,
        limit: 10,
      },
      loading: false,
      error: false,
      finished: false,
      finishText: '',
      isEmpty: false,
      dialogVisable: false,
      item: '',
      reason: ''
    }
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
    });
    this.getList()
  },

  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    beforeEnter(dom) {
      let { x = 0, y = 0, s = 1, opacity = 0 } = dom.dataset
      dom.style.cssText = `transition: .2s;opacity: ${opacity};transform: scale(${s}) translateX(${x}) translateY(${y});`
    },
    enter(dom, done) {
      let delay = dom.dataset.delay
      setTimeout(function () {
        dom.style.cssText = `transition: .2s;opacity: 1;transform: scale(1) translateX(0) translateY(0);`
        //监听 transitionend 事件
        var transitionend = window.ontransitionend
          ? 'transitionend'
          : 'webkitTransitionEnd'
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd)
          done() //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        })
      }, delay)
    },
    afterEnter(dom) {
      dom.style.cssText = ''
    },
    handleApplyRefund(item) {
      this.dialogVisable = true
      this.item = item
    },
    handleSubmitRefund() {
      if (!this.reason) {
        this.$toast({
          message: '请输入退款原因',
          position: 'bottom'
        })
        return
      }
      applyForRefund({ id: this.item.id, reason: this.reason }).then(res => {
        if (res) {
          this.$toast({
            message: "已成功申请退款，请等待商家审核",
            position: "bottom",
          });
          // this.$set(this.item, 'validFlag', 1)
            this.pageInfo.page = 1
            this.getList('reset')
        }
        this.dialogVisable = false
      })
    },
    getList(type) {
      let _this = this
      let obj = Object.assign({}, _this.pageInfo)
      myAssetsList(obj)
        .then((res) => {
          if (res) {
            if (res.data.totalCount == 0) {
              _this.isEmpty = true
            } else {
              _this.isEmpty = false
            }
            if (!res.data.list) {
              _this.finished = true
              return
            }
            if (type == 'reset') {
              _this.dataList = []
              _this.finishText = ''
            }
            setTimeout(() => {
              _this.dataList.push(...res.data.list)
              _this.loading = false
              if (res.data.currPage === res.data.totalPage &&res.data.totalCount>0) {
                _this.finished = true
                _this.finishText = '亲，已经到底啦'
                return
              }
            }, 300)
          } else {
            _this.isEmpty = true
             _this.dataList = []
            _this.finishText=''
          }
          _this.$toast.clear()
        })
        .catch(() => {
          _this.$toast.clear()
        })
    },
    onLoad() {
      this.pageInfo.page++
      this.getList()
    },
    handleRecDeatails(id) {
      return
      // this.$router.push({ name: 'actDetail', query: { id: id } })
    },
  },
}
</script>
